import React, { useState } from "react";
import { MessageCircle, Copy, CheckCircle, Clock, Globe } from "lucide-react";

function ContactUs() {
  const [copied, setCopied] = useState(false);
  const whatsappNumber = "+12797901187";
  const whatsappLink = "https://wa.me/12797901187";

  const copyToClipboard = () => {
    navigator.clipboard.writeText(whatsappNumber.replace(/\s/g, ''));
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const openWhatsApp = () => {
    window.open(whatsappLink, '_blank');
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center p-4 transition-colors duration-200">
      <div className="max-w-md w-full bg-white dark:bg-gray-800 rounded-2xl shadow-xl dark:shadow-2xl overflow-hidden transition-colors duration-200">
        <div className="bg-gradient-to-r from-green-600 to-green-700 dark:from-green-700 dark:to-green-800 px-6 py-8 text-center">
          <div className="w-20 h-20 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4 backdrop-blur-sm">
            <MessageCircle className="w-10 h-10 text-white" />
          </div>
          <h1 className="text-2xl font-bold text-white mb-2">Contact Us</h1>
          <p className="text-green-100 text-sm">We're here to help 24/7</p>
        </div>
        
        <div className="p-6">
          <div className="bg-gray-50 dark:bg-gray-700/50 rounded-xl p-4 mb-4 transition-colors duration-200">
            <div className="text-sm text-gray-500 dark:text-gray-400 mb-1">WhatsApp Number</div>
            <div className="flex items-center justify-between">
              <span className="text-xl font-bold text-gray-800 dark:text-gray-200">
                {whatsappNumber}
              </span>
              <button
                onClick={copyToClipboard}
                className="p-2 hover:bg-gray-200 dark:hover:bg-gray-600 rounded-lg transition-colors"
                aria-label="Copy number"
              >
                {copied ? (
                  <CheckCircle size={20} className="text-green-600 dark:text-green-400" />
                ) : (
                  <Copy size={20} className="text-gray-500 dark:text-gray-400" />
                )}
              </button>
            </div>
          </div>

          <div className="space-y-3 mb-6">
            <button
              onClick={openWhatsApp}
              className="w-full bg-green-600 hover:bg-green-700 dark:bg-green-700 dark:hover:bg-green-800 text-white font-semibold py-3 px-4 rounded-xl flex items-center justify-center gap-2 transition-all duration-200 transform hover:scale-[1.02]"
            >
              <MessageCircle size={20} />
              Open WhatsApp
            </button>
            
            <button
              onClick={copyToClipboard}
              className="w-full bg-gray-100 hover:bg-gray-200 dark:bg-gray-700 dark:hover:bg-gray-600 text-gray-800 dark:text-gray-200 font-semibold py-3 px-4 rounded-xl flex items-center justify-center gap-2 transition-all duration-200"
            >
              <Copy size={20} />
              Copy Number
            </button>
          </div>

          <div className="border-t border-gray-100 dark:border-gray-700 pt-4">
            <div className="flex items-center justify-between text-sm">
              <div className="flex items-center gap-2 text-gray-500 dark:text-gray-400">
                <Clock size={14} />
                <span>Available 24/7</span>
              </div>
              <div className="flex items-center gap-2 text-gray-500 dark:text-gray-400">
                <Globe size={14} />
                <span>Worldwide Support</span>
              </div>
            </div>
          </div>

          <p className="text-xs text-gray-400 dark:text-gray-500 text-center mt-4">
            Tap to chat • Quick response time
          </p>
        </div>
      </div>
    </div>
  );
}

export default ContactUs;